import { ThemeProvider } from "@emotion/react";
import * as React from "react";

import thumbsUp from "assets/svg/thumbs-up.svg";
import { legacyTheme } from "themes/legacyTheme";

import { Container, Header, Headline, StepImage, Wrapper } from "./styled";

const TicketRatingAlreadyRated: React.FC = () => (
  <ThemeProvider theme={legacyTheme}>
    <Container>
      <Wrapper>
        <StepImage src={thumbsUp} />
        <Header>The ticket has already been rated.</Header>
        <Headline>Thank you for your feedback.</Headline>
      </Wrapper>
    </Container>
  </ThemeProvider>
);

export default TicketRatingAlreadyRated;
